// extracted by extract-css-chunks-webpack-plugin
module.exports = {"map":"map___22guv"};